// New track (a space's page, desktop and phone): the name and its lead (partners do not lead tracks). Saves directly.
import { useState } from 'react';
import { can, type Member } from '@dpw/shared';
import { api } from '../api';
import { useChange } from '../lib/queries';
import { usePhone } from '../lib/media';
import { ErrorNote } from './bits';
import { Sheet } from './Sheet';
import { PSheet } from '../phone/kit';

export function NewTrack({ spaceId, members: all, onClose }: { spaceId: string; members: Member[]; onClose: () => void }) {
  const phone = usePhone();
  const members = all.filter(m => can(m.userRole, 'activity.own'));
  const [name, setName] = useState('');
  const [lead, setLead] = useState('');
  const create = useChange(() => api.spaces.createTrack(spaceId, { name: name.trim(), leadUserId: lead || null }));
  const inp = phone ? 'ph-inp' : 'inp';
  const form = (
    <form className={phone ? 'col gap12' : undefined} onSubmit={e => { e.preventDefault(); create.mutate(undefined, { onSuccess: onClose }); }} aria-label="New track">
      <label className="fld">Name<input className={inp} value={name} onChange={e => setName(e.target.value)} required autoFocus placeholder="A workstream, e.g. Governance and Policy" maxLength={120} /></label>
      <label className="fld">Lead<select className={inp} value={lead} onChange={e => setLead(e.target.value)}><option value="">No lead yet</option>{members.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}</select></label>
      {create.error ? <ErrorNote error={create.error} /> : null}
      {phone ? <button className="ph-btf" disabled={create.isPending || !name.trim()}>Create track</button>
        : <div className="rowc"><button className="bt pri" disabled={create.isPending || !name.trim()}>Create track</button><button type="button" className="bt" onClick={onClose}>Cancel</button></div>}
    </form>
  );
  if (phone) return <PSheet label="New track" onClose={onClose}><h2>New track</h2>{form}</PSheet>;
  return <Sheet crumbs={<b>New track</b>} onClose={onClose} width={520} label="New track">{form}</Sheet>;
}
